import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { FormValidationContext } from '../../benefit/common/FormValidationContext';
import { useBootstrapValidation } from '../hooks/userBootstrapValidation';
import { useHydratedForm } from '../hooks/useHydratedForm';
import { hasMeaningfulChange } from '../../../utils/hasMeaningfulChange';
import { useUI } from '../../../context/UIContext';
import CurrencyField from '../../benefit/fields/CurrencyField';
import EffectiveDateField from '../common/EffectiveDateField';
import { calculatorService } from '../../../services/calculatorService';
import { useState } from 'react';

const mapAmiToForm = (ami) => ({
  id: ami.id,
  county: ami.county,
  householdSize: ami.householdSize,
  ami: ami.ami ?? '',
  effectiveDate: ami.effectiveDate ?? '',
});

const MEANINGFUL_FIELDS = ['ami', 'effectiveDate'];

const EditAmiModal = ({ ami, onSave, onClose }) => {
  const [form, setForm] = useHydratedForm(ami, mapAmiToForm);

  const { validated, validateForm } = useBootstrapValidation();
  const [customError, setCustomError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState('');
  const { showLoading, hideLoading, showError, showSuccess } = useUI();

  if (!ami) return null;

  const handleSubmit = async (e) => {
    const formEl = e.currentTarget;
    e.preventDefault();

    if (!hasMeaningfulChange(ami, form, MEANINGFUL_FIELDS)) {
      setCustomError(
        'At least one value must be changed before saving.'
      );
      return;
    }

    if (!validateForm(formEl)) return;
    setIsSubmitting(true);
    showLoading('Saving AMI…');
    try {
      const res = await calculatorService.saveAmi(form);
      setIsSubmitting(false);
      if (res.success) {
        onSave(res.data);
        onClose();
        showSuccess('AMI configuration saved.');
      } else {
        showError(res.error);
      }
    } finally {
      setIsSubmitting(false);
      hideLoading();
    }
  };

  return (
    <Modal show onHide={onClose} centered>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <FormValidationContext.Provider value={validated}>
          <Modal.Header closeButton>
            <Modal.Title>
              Edit AMI — {form.county}, Household {form.householdSize}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Row>
              <Col>
                <CurrencyField
                  required
                  fieldName="AMI"
                  value={form.ami}
                  scale={0}
                  onChange={(v) => setForm({ ...form, ami: v })}
                  isSubmitting={isSubmitting}
                />
              </Col>
              <Col>
                <EffectiveDateField
                  value={form.effectiveDate}
                  onChange={(v) => setForm({ ...form, effectiveDate: v })}
                  isSubmitting={isSubmitting}
                />
              </Col>
            </Row>
            {customError && (
              <div className="text-danger mt-3">{customError}</div>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={onClose} variant="secondary">Cancel</Button>
            <Button variant="primary" type="submit">Save</Button>
          </Modal.Footer>
        </FormValidationContext.Provider>
      </Form>
    </Modal>
  );
};

export default EditAmiModal;